import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/solid.min.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/master.css";

import goTo from 'vuetify/lib/services/goto';
import VuePageTransition from 'vue-page-transition'

import VueMeta from 'vue-meta';
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import VueGtag from "vue-gtag";

Vue.use(VueAddtohomescreen);
Vue.use(VueMeta);

Vue.use(VuePageTransition)

Vue.prototype.$baseUrl = "https://api.aylarkhani.com/";
//Vue.prototype.$baseUrl = "https://localhost:44319/";

Vue.prototype.$replaceHttps = function (httpUrl) {
  if (httpUrl !== null) {
    return httpUrl.replace('http://', 'https://');
  }
};

Vue.prototype.$numberWithCommas = function (x) {
  if(x !== null) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

Vue.prototype.$scrollTop = function (x) {
  return goTo(x);
}

Vue.prototype.$keywords = 'آموزش کراتین مو در تهرانپارس, آموزش رنگ مو در تهرانپارس, آموزش هایلایت مو در تهرانپارس, آموزش دکلره مو در تهرانپارس, آموزش آمبره مو در تهرانپارس,آموزش رنگ و مش مو در تهرانپارس, آموزش مزوتراپی سر در تهرانپارس, آموزش شینیون مو در تهرانپارس, آموزش کراتین مو در تهران, آموزش شینیون مو در تهران, آموزش رنگ مو در تهران, آموزش رنگ و مش در تهران';

Vue.config.productionTip = true;

Vue.use(VueGtag, {
  config: { id: "G-T1TY5S1X91" },
  params: {
    send_page_view: false,
    pageTrackerScreenviewEnabled: true
  },
}, router);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
